module.exports = __webpack_public_path__ + "img/eu-4.8a138dc6.jpg";